// import { io } from "socket.io-client";

// const socket = io("https://uat.foxearch.com/", {
//   transports: ["websocket"],
//   autoConnect: true,
// });

// export default socket;

import { io } from "socket.io-client";

const socket = io("https://uat.foxearch.com/", {
// const socket = io( "http://ec2-3-111-181-217.ap-south-1.compute.amazonaws.com:8000/", {
 
  transports: ["polling", "websocket"],
  autoConnect: true,
});

export default socket;